import styled from 'styled-components';
import { colors } from '../../utils/constants';

export const ContainerForm = styled.div`
  background-color: white;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 5px;
  box-shadow: 1px 2px 2px 2px ${colors.grey};
`;
